import { useState } from 'react';
import { accountsApi } from '../../../shared/api/accounts.api';
import { toast } from 'sonner@2.0.3';

/**
 * Хук для обновления данных аккаунта (аватарка, подписчики и т.д.)
 */
export function useRefreshAccount() {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refresh = async (accountId: string, username: string, onSuccess?: () => void) => {
    setIsRefreshing(true);
    try {
      const result = await accountsApi.refresh(accountId);
      
      if (result.valid) {
        toast.success(`Аккаунт @${username} обновлен`);
        onSuccess?.();
      } else {
        toast.error(result.error || 'Не удалось обновить аккаунт');
      }
      
      return result;
    } catch (error) {
      console.error('Error refreshing account:', error);
      toast.error('Ошибка при обновлении аккаунта');
      throw error;
    } finally {
      setIsRefreshing(false);
    }
  };

  return {
    refresh,
    isRefreshing,
  };
}
